import React from 'react';
import { FormText, TextArea, Fieldset, Selectize } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { REVEALED_PHASE_OPTIONS } from '~/config/constants';
import { Col } from 'react-bootstrap';

function BasicInfo({ asyncApiCall }) {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>Basic Info:</Fieldset.Legend>
            <FormText
                name="name"
                asyncApiCall={asyncApiCall}
                sm={12}
            />
            <TextArea
                name="description"
                rows={2}
                sm={12}
                className="mt-3"
            />
            <Selectize
                as={Col}
                sm={12}
                name="phaseRestrictionOptions"
                options={REVEALED_PHASE_OPTIONS}
                className="mt-3"
            />
        </Fieldset>
    );
}

BasicInfo.propTypes = {
    asyncApiCall: PropTypes.func.isRequired,
};
export default BasicInfo;
